import React from "react";
import OperationalDocumentEditor from "../common/OperationalDocumentEditor";
import { BonConsumForm } from "../bon_consum/Form";

export default function BonTransferCreate() {
  return <OperationalDocumentEditor create kind="transfer" FormComponent={BonConsumForm} />;
}
